import styled from 'styled-components';

import Page from 'xpi-black-ui/Base/Page';
import KeyValue from 'xpi-black-ui/Common/KeyValue/styles';
import ContentBox from 'xpi-black-ui/Base/ContentBox/styles';
import ContentDivider from 'xpi-black-ui/Common/ContentDivider/styles';

export default styled(Page)`
  display: block;

  ${ContentBox} {
    padding: 24px;
    margin-bottom: 8px;
  }

  soma-tooltip span {
    color: inherit;
    line-height: 21px;
  }

  .title {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
  }
`;

export const GoBackStyles = styled.div`
  & > div {
    margin: 24px 0;
  }
`;

export const ProductContent = styled.div`
  .margin-bottom {
    margin-bottom: 24px;
  }

  .header {
    margin: 24px 0;

    .logo {
      width: 54px;
      height: 54px;
      margin-right: 16px
    }

    .name {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 9px;
    }

    .structure {
      font-size: 16px;
    }

    .buttons {
      soma-button:first-child {
        width: 160px;
        line-height: 24px;
        margin-right: 16px;
      }
      soma-button:last-child {
        width: 155px;
      }
    }
  }

  .icon-info {
    top: 4px;
    left: 4px;
    position: relative;
  }
`;

export const Introduction = styled.div`
  margin-top: 50px;

  ${KeyValue} {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
`;

export const Profitability = styled.div`
  p.value {
    margin-left: 3px;
    margin-bottom: 0;
  }

  soma-icon {
    bottom: 1px;
    position: relative;
  }

  ${ContentDivider} {
    padding: 0 48px;

    &:first-child {
      padding-left: 0;
    }
  }
`;

export const StructureItem = styled.div`
  margin-right: 10px;
  margin-right: 40px;
  display: inline-block;
`;

export const StructureIndex = styled.span`
  width: 24px;
  height: 24px;
  padding: 5px;
  line-height: 14px;
  border-radius: 50%;
  text-align: center;
  margin-right: 8px;
  background: #2e2e33;
  display: inline-block;
`;


export const Scenarios = styled.div`
  display: flex;
`;

export const ScenariosTable = styled.div`
  width: 90%;
`;

export const ScenariosDesciption = styled.div`
  width: 90%;
  margin-left: 40px;

  & > div:not(:last-child) {
    margin-bottom: 24px;
  }
`;
